import { Context, Layer, type Cause, type Effect, type Scope } from "effect";
import type { EditorElementFocusFailure, EditorElementId } from "./element-focus-model.ts";

export class EditorElementFocusIo extends Context.Service<EditorElementFocusIo, {
  readonly frame: Effect.Effect<unknown, EditorElementFocusFailure>;
  readonly focus: (target: HTMLElement, id: EditorElementId) => Effect.Effect<unknown, EditorElementFocusFailure>;
}>()("workerstation/frontend/EditorElementFocusIo") {}
export const EditorElementFocusIoTest = (io: typeof EditorElementFocusIo.Service) => Layer.succeed(EditorElementFocusIo, io);
export interface EditorElementFocusSession {
  readonly focus: (target: HTMLElement | null, id: unknown) => Effect.Effect<void>;
}
export class EditorElementFocusSessions extends Context.Service<EditorElementFocusSessions, {
  readonly open: (isCurrent: (target: HTMLElement, id: EditorElementId) => unknown) => Effect.Effect<EditorElementFocusSession, never, Scope.Scope>;
  readonly failures: Effect.Effect<readonly Cause.Cause<EditorElementFocusFailure>[]>;
}>()("workerstation/frontend/EditorElementFocusSessions") {}
